import React, {useEffect, useState} from 'react'
import {Card, Col, Row, Space, Table, Collapse, Tag} from "antd";
import {involvedBrandOfferReports, notInvolvedBrandOfferReports, nonZeroStock, brandBasedOffers} from "../../services/serviceReports";
import Filter from "../filterWrapper/Filter";
import InvolvedBrandCluster from "./brandClusteredOfferFilters/involvedBrandFilters";
import NotInvolvedBrandCluster from "./brandClusteredOfferFilters/notInvolvedBrandFilters";
import {SearchOutlined} from "@ant-design/icons";
import BarChart from "../charts/BarChart";
import BrandClusterFilter from './brandClusteredOfferFilters/brancClusterFilter';
import config from "../../config";
import { createMonthlyDateRange } from '../../utils/helpers/commonFunctions';

const setTableRowKeys = (r, index) => index;
const {Panel} = Collapse;

const FILTER_KEYS = {
    0: <InvolvedBrandCluster />,
    1: <NotInvolvedBrandCluster />,
    2: <BrandClusterFilter />
};

const bidStatuses = {
    WAITING: <Tag color={"cyan"}>BEKLEMEDE</Tag>,
    POSITIVE: <Tag color={"green"}>OLUMLU </Tag>,
    NEGATIVE: <Tag color={"red"}>OLUMSUZ</Tag>
};

const currencies = {
    EUR: <Tag color={"purple"}>EUR</Tag>,
    TRY: <Tag color={"magenta"}>TRY</Tag>,
    USD: <Tag color={"orange"}>USD</Tag>,
};

const currencyFilter = [
    {text: 'EUR', value: 'EUR'},
    {text: 'TRY', value: 'TRY'},
    {text: 'USD', value: 'USD'}
];

const BrandClusteredOfferReports = () => {
    const [notInvolvedData, setNotInvolvedData] = useState()
    const [involvedData, setInvolvedData] = useState([])
    const [involvedChart, setInvolvedChart] = useState()
    const [giftData, setGiftData] = useState([])
    const [noneZeroData, setNoneZeroData] = useState()
    const [openFilter, setOpenFilter] = useState(false)
    const [filterStatus, setFilterStatus] = useState()
    const [brandClusteredData, setBrandClusteredData] = useState([])

    useEffect(() => {
        getNoneZeroOffers()
    }, [])

    const getNoneZeroOffers = () => {
        nonZeroStock()
            .then(({data}) => setNoneZeroData(data))
    }

    // handlers
    const involvedHandler = (params) => {
        involvedBrandOfferReports(params)
                .then(({data}) => {
                    createInvolvedChartData(data.usedStockCountReportDTOS)
                    setInvolvedData(data.usedStockCountReportDTOS)
                    setGiftData(data.giftStockCountReportDTOS)
                })
    };
    const notInvolvedHandler = (params) => {
        notInvolvedBrandOfferReports(params)
        .then(({data}) => setNotInvolvedData(data))
    };
    const brandClusteredHandler = (params) => {
        const requestObj = {...params};

        if(!requestObj.dateRange) {
            const [startDate, endDate] = createMonthlyDateRange();
            requestObj.startDate = startDate;
            requestObj.endDate = endDate;
        }else {
            requestObj.startDate = requestObj.dateRange[0]._d;
            requestObj.endDate = requestObj.dateRange[1]._d;
        };

        delete requestObj.dateRange;
        
        brandBasedOffers(requestObj)
         .then(({data}) => setBrandClusteredData(data));
    };

    const requestHandlers = {
        0: involvedHandler,
        1: notInvolvedHandler,
        2: brandClusteredHandler
    };

    // resets
    const clearInvolved = () => setInvolvedData([])
    const clearNotInvolved = () => setNotInvolvedData([])
    const clearBrandBased = () => setBrandClusteredData([]);
    const formResets = {
        0: clearInvolved,
        1: clearNotInvolved,
        2: clearBrandBased
    }

    // filter display 
    const toggleFilterDisplay = () => setOpenFilter(!openFilter)
    const changeFilterStatus = (status) => {
        setFilterStatus(status)
        toggleFilterDisplay()
    }

    // columns
    const noneZeroColumns = [
        {title: 'Marka', dataIndex: 'b'},
        {title: 'Stok Kodu', dataIndex: 'c'},
        {title: 'Stok Adı', dataIndex: 'n'},
        {title: 'Stok Açıklaması', dataIndex: 'd'},
        {title: 'Depo', dataIndex: 'w'}
    ];
    const notInvolvedColumns = [
        {title: 'Marka', dataIndex: 'b'},
        {title: 'Stok Kodu', dataIndex: 'c'},
        {title: 'Stok Adı', dataIndex: 'n'},
        {title: 'Stok Açıklaması', dataIndex: 'd'},
        {title: 'Depo', dataIndex: 'w'}
    ];
    const involvedColumns = [
        {title: 'Marka', dataIndex: 'b'},
        {title: 'Stok', dataIndex: 's'},
        {title: 'Stok Adı', dataIndex: 'n'},
        {title: 'Stok Açıklaması', dataIndex: 'd'},
        {title: 'Miktar', dataIndex: 'q'},
    ];
    const giftColumns = [
        {title: 'Teklif', dataIndex: 'b'},
        {title: 'Stok Kodu', dataIndex: 's'},
        {title: 'Stok Adı', dataIndex: 'n'},
        {title: 'Adet', dataIndex: 'q'}
    ];
    const brandClusteredColumns = [
        {title: 'Para Birimi', dataIndex: "currency",filters: currencyFilter, onFilter: (value, record) => record.currency.indexOf(value) === 0, render: (t) => currencies[t]},
        {title: 'Teklif Durumu', dataIndex: "bidStatus", render: (t) => bidStatuses[t]},
        {title: 'Vergi Hariç Fiyat', dataIndex: "priceExcludingTax", render: (t) => new Intl.NumberFormat().format(t)},
        {title: 'Vergi Dahil Fiyat', dataIndex: "priceIncludingTax", render: (t) => new Intl.NumberFormat().format(t)},
        {title: 'Teklif Sayısı', dataIndex: "count"}
    ]

    const handleFilter = (...filterData) => {
        requestHandlers[filterStatus](filterData[0]);

        return new Promise((resolve, reject) => {
            resolve(true)
            reject(false)
        })
    };

    const createInvolvedChartData = (data) => {
        const sortedList = (data.sort((curr, acc) => acc.q - curr.q))
        setInvolvedChart(sortedList)
    }


    return(
        <React.Fragment>
            <Card
                title={'Marka Bazlı Teklif Raporları'}
            >
                <Space direction={"vertical"} size={'large'} style={{width: '100%'}}>
                    <Collapse accordion defaultActiveKey={['0']}>
                        <Panel header={'En Fazla Kullanılan Markalar / Stoklar'} key={'0'}>
                            <Row justify={"start"}>
                                <div className={'filter-row-container'} onClick={() => changeFilterStatus(0)}><SearchOutlined/></div>
                            </Row>
                            {
                                involvedData.length ?
                                    <Row>
                                        <Col span={12}>
                                            <BarChart
                                                xAxis={involvedChart.slice(0,10).map(item => item.s)}
                                                yAxis={involvedChart.slice(0,10).map(item => item.q)}
                                                ySet={'Miktar'}
                                                xSet={'Stok'}
                                            />
                                        </Col>
                                    </Row>
                                    : null
                            }
                            <Space direction={'vertical'} size={'large'} style={{width: '100%'}}>
                                <Table rowKey={setTableRowKeys} columns={involvedColumns} dataSource={involvedData} scroll={{x: 'max-content'}}/>
                                <h4>Hediye Gönderilen Stoklar</h4>
                                <Table dataSource={giftData} columns={giftColumns}  scroll={{x: 'max-content'}}/>
                            </Space>
                        </Panel>
                        <Panel header={'Stoğu Olup Teklifte Geçmeyen Markalar/Stoklar'} key={'1'}>
                            <Table rowKey={setTableRowKeys} columns={noneZeroColumns} dataSource={noneZeroData} scroll={{x: 'max-content'}}/>
                        </Panel>
                        <Panel header={'Teklif İçerisinde Kullanılmayan Stoklar'} key={'2'}>
                            <Row justify={"start"}>
                                <div className={'filter-row-container'} onClick={() => changeFilterStatus(1)}><SearchOutlined/></div>
                            </Row>
                            <Table rowKey={setTableRowKeys} columns={notInvolvedColumns} dataSource={notInvolvedData} scroll={{x: 'max-content'}}/>
                        </Panel>
                        <Panel header={'Marka ve Çalışan Bazlı Teklifler'} key={'3'}>
                            <Row justify={"start"}>
                                <div className={'filter-row-container'} onClick={() => changeFilterStatus(2)}><SearchOutlined/></div>
                            </Row>
                            <Table rowKey={setTableRowKeys} columns={brandClusteredColumns} dataSource={brandClusteredData} scroll={{x: 'max-content'}}/>
                        </Panel>
                    </Collapse>

                </Space>
            </Card>

            {
                <Filter
                    showDrawer={openFilter}
                    closer={toggleFilterDisplay}
                    relatedComponent={'Marka Bazlı Teklif Raporlama'}
                    handler={handleFilter}
                    resetHandler={ formResets[filterStatus] }
                >
                    {
                        FILTER_KEYS[filterStatus]
                    }
                </Filter>
            }
        </React.Fragment>
    )
}
export default BrandClusteredOfferReports